import React, { useMemo } from 'react';
// Antd
import { Modal } from 'antd';
import { MdOutlineArrowBackIosNew } from "react-icons/md"
// helpers
import get from 'lodash/get'
import { actionTypeDict } from './actionTypeDict';
import UserCard from './UserCard';
import styles from "./styles.module.scss"
import TicketCard from './TicketCart';

interface ModalLocationInterface {
  metadata: any,
  handleCancel: () => void
}

const getUserInfo = (type) => type === "previousInfo" ? "Información anterior" : "Usuario transferido"

const ModalLogInfo: React.FC<ModalLocationInterface> = ({ metadata, handleCancel }) => {
  const actionType = get(metadata, "actionType", "null")
  const userInfo = get(metadata, "userInfo", get(metadata, "user", null))
  const ticket = get(metadata, "ticket", null)

  const secondUserInfo = useMemo(() => {
    if (get(metadata, "lastUserInfo", null) !== null) return { info: get(metadata, "lastUserInfo", null), infoType: "previousInfo" }
    if (get(metadata, "transferedUserInfo", null) !== null) return { info: get(metadata, "transferedUserInfo", null), infoType: "transferedUser" }
    return { infoType: null }
  }, [])

  return (
    <Modal
      open
      destroyOnClose
      footer={null}
      className={styles.modal}
      title={actionTypeDict[actionType]}
      onCancel={handleCancel}
    >

      <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
        <div className="MergeUser">
          <div className="usersMergeData">
            {userInfo && <UserCard user={userInfo} title='Usuario' />}
            {ticket && <TicketCard {...ticket} />}
            {secondUserInfo.infoType && (
              <>
                <MdOutlineArrowBackIosNew color="#0061df" fontSize={30} />
                <UserCard user={secondUserInfo.info} title={getUserInfo(secondUserInfo.infoType)} />
              </>
            )}
          </div>
        </div>
      </div>

    </Modal>
  );
};

export default ModalLogInfo;